// import type { GameThemeId } from "@skillscratch/shared-types";

// Standard bonus scratches configuration (previously highBonusScratches)
const BONUS_SCRATCHES = {
    "2,0": 6,
    "2,1": 5,
    "2,2": 4,
    "2,3": 3,
    "2,4": 2,
    "2,5": 1,
    "3,2": 4,
    "3,3": 3,
    "3,4": 2,
    "3,5": 1,
} as const satisfies Record<`${number},${number}`, number>;

// Treasure injections (kept from original code)
// export const treasureInjections = {
//     0: 10,
//     1: 12,
//     2: 13,
//     3: 14,
//     4: 15,
// } as const satisfies Record<number, number>;

/**
 * Get bonus scratches based on treasures found and lose streak
 */
export function getBonusScratches(
    treasuresFound: number, 
    loseStreak: number, 
): number {
    // Limit lose streak to max 3
    const maxLoseStreak = Math.min(loseStreak, 3);
    const key = `${maxLoseStreak},${treasuresFound}`;

    // Return bonus scratches if configuration exists for this combination
    if (key in BONUS_SCRATCHES) {
        return BONUS_SCRATCHES[key as keyof typeof BONUS_SCRATCHES];
    }

    // Default fallback
    return 0;
}